import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import store from './store';
import './registerServiceWorker';

import VueWaypoint from 'vue-waypoint';
Vue.use(VueWaypoint);

import * as BG from '@/bgscene/bgscene.js';
let bgscene = new BG.Scene();
bgscene.initialize();
bgscene.animate();
Vue.prototype.$bgscene = bgscene;

Vue.config.productionTip = false;

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app');
